function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M92.0639 94.7852C85.5939 95.5056 79.7509 90.8336 79.0304 84.3636L75.0484 48.6046C74.4087 42.8601 78.0285 37.5972 83.3741 35.9957L83.2402 34.7932C81.548 19.5971 92.5437 5.84569 107.75 4.15241C122.956 2.45912 136.697 13.4559 138.389 28.652L138.521 29.8346C144.143 30.1745 148.884 34.5266 149.528 40.3108L153.51 76.0698C154.231 82.5398 149.558 88.3828 143.088 89.1032L92.0639 94.7852ZM118.526 31.8902L118.413 30.8765C117.947 26.6923 114.158 23.663 109.974 24.1289C105.79 24.5949 102.761 28.3834 103.227 32.5675L103.34 33.5813L118.526 31.8902Z",
  fill: "#111927"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M97.4219 40.9818L96.5675 33.3092C95.692 25.4478 101.371 18.3457 109.232 17.4703C117.094 16.5949 124.196 22.2737 125.071 30.1352L125.926 37.8077L132.585 37.0662L131.73 29.3936C130.446 17.8649 120.02 9.52764 108.491 10.8114C96.9621 12.0952 88.6248 22.522 89.9086 34.0507L90.763 41.7233L97.4219 40.9818V40.9818Z",
  stroke: "white",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M137.236 36.548L86.2112 42.2299C83.4119 42.5417 81.3953 45.0637 81.707 47.863L85.689 83.622C86.0007 86.4214 88.5227 88.438 91.3221 88.1263L142.347 82.4443C145.146 82.1326 147.163 79.6106 146.851 76.8113L142.869 41.0523C142.557 38.2529 140.035 36.2363 137.236 36.548Z",
  stroke: "white",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M118.824 56.0758C119.052 58.1232 118.076 60.0129 116.49 61.0447L117.265 68.0017L112.504 68.5318L111.729 61.5748C109.956 60.9171 108.588 59.2985 108.359 57.2412C108.041 54.3888 110.126 51.7821 113.018 51.4601C115.91 51.138 118.517 53.2224 118.834 56.0747L118.824 56.0758Z",
  stroke: "white",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M186.127 182.782C156.144 180.496 133.609 154.243 135.895 124.26L139.101 82.1948C141.387 52.2113 167.64 29.677 197.623 31.9625C227.607 34.248 250.141 60.501 247.856 90.4846L244.649 132.549C242.364 162.533 216.111 185.067 186.127 182.782Z",
  fill: "#00C16B"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M240.634 89.9345C242.619 63.8913 223.116 41.1699 197.073 39.1847C171.03 37.1996 148.309 56.7025 146.324 82.7457L143.117 124.81C141.132 150.854 160.635 173.575 186.678 175.56C212.721 177.545 235.443 158.042 237.428 131.999L240.634 89.9345Z",
  stroke: "#111927",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M231.29 87.9723L155.345 82.1834C152.674 81.9798 150.345 83.9795 150.141 86.6497L150.14 86.6619C149.937 89.3321 151.936 91.6618 154.607 91.8653L230.552 97.6542C233.222 97.8578 235.552 95.8581 235.755 93.1879L235.756 93.1757C235.96 90.5055 233.96 88.1758 231.29 87.9723Z",
  stroke: "#111927",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M204.672 113.848L204.541 115.565C204.523 114.988 204.567 114.415 204.672 113.848Z",
  fill: "#111927"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M214.987 100.167C211.504 99.9018 208.199 100.838 205.479 102.615C205.363 102.692 205.26 102.758 205.144 102.835C196.896 108.036 186.215 107.222 178.851 100.83C178.747 100.737 178.656 100.656 178.552 100.563C176.133 98.3938 173.008 96.9674 169.525 96.7019C161.134 96.0623 153.807 102.351 153.167 110.754C152.526 119.158 158.816 126.472 167.207 127.112C170.739 127.381 174.082 126.423 176.818 124.598C184.837 119.354 195.258 119.879 202.675 125.749C205.199 128.464 208.699 130.274 212.67 130.577C221.061 131.217 228.387 124.928 229.027 116.537C229.666 108.146 223.379 100.807 214.987 100.167ZM174.418 118.964C170.525 122.306 164.655 121.858 161.314 117.966C157.974 114.061 158.42 108.203 162.313 104.861C166.206 101.52 172.076 101.968 175.417 105.86C178.758 109.753 178.312 115.611 174.418 118.964ZM219.881 122.43C215.988 125.771 210.118 125.324 206.777 121.431C205.326 119.728 204.578 117.65 204.539 115.589L204.541 115.565C204.524 114.988 204.567 114.415 204.672 113.847C204.662 113.822 204.663 113.81 204.677 113.787C205.029 111.731 206.072 109.789 207.775 108.327C211.668 104.985 217.538 105.433 220.88 109.326C224.221 113.218 223.774 119.076 219.881 122.43Z",
  fill: "#111927"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M172.397 116.728C169.736 119.012 165.729 118.706 163.433 116.045C162.668 115.153 162.196 114.113 162.008 113.045L166.357 111.76L162.253 109.83C162.602 108.791 163.225 107.846 164.116 107.081C166.79 104.786 170.797 105.092 173.08 107.764C175.376 110.426 175.069 114.445 172.397 116.728Z",
  fill: "#111927"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M204.672 113.848L204.541 115.565C204.523 114.988 204.567 114.415 204.672 113.848Z",
  fill: "#111927"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M204.672 113.848L204.541 115.565C204.523 114.988 204.567 114.415 204.672 113.848Z",
  fill: "#FFD417"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M217.858 120.193C215.198 122.477 211.191 122.171 208.895 119.51C208.13 118.619 207.658 117.578 207.47 116.51L211.818 115.225L207.715 113.295C208.064 112.256 208.687 111.311 209.578 110.546C212.252 108.251 216.259 108.557 218.542 111.23C220.838 113.891 220.531 117.91 217.858 120.193Z",
  fill: "#111927"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M172.397 116.728C169.736 119.012 165.729 118.706 163.433 116.045C162.668 115.153 162.196 114.113 162.008 113.045L166.357 111.76L162.253 109.83C162.602 108.791 163.225 107.846 164.116 107.081C166.79 104.786 170.797 105.092 173.08 107.764C175.376 110.426 175.069 114.445 172.397 116.728Z",
  fill: "#FFD417"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M172.397 116.728C169.736 119.012 165.729 118.706 163.433 116.045C162.668 115.153 162.196 114.113 162.008 113.045L166.357 111.76L162.253 109.83C162.602 108.791 163.225 107.846 164.116 107.081C166.79 104.786 170.797 105.092 173.08 107.764C175.376 110.426 175.069 114.445 172.397 116.728Z",
  fill: "#111927"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M166.955 141.988L169.982 141.802C169.904 142.825 170.43 143.477 171.271 143.541C171.928 143.592 172.382 143.271 172.421 142.747C172.46 142.248 172.166 141.919 171.38 141.627L170.344 141.241C168.255 140.519 167.408 139.425 167.545 137.623C167.708 135.479 169.259 134.262 171.792 134.455C172.9 134.54 173.779 134.901 174.431 135.514C175.082 136.127 175.387 136.947 175.347 137.948L172.422 138.24C172.486 137.399 172.112 136.844 171.527 136.799C171.028 136.761 170.649 137.075 170.611 137.575C170.573 138.074 170.878 138.404 171.737 138.714L172.737 139.084C174.823 139.843 175.661 140.9 175.527 142.665C175.36 144.858 173.656 146.161 170.964 145.956C168.468 145.765 166.903 144.274 166.991 142.002L166.955 141.988Z",
  fill: "#111927"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M176.616 140.593C176.883 137.085 179.003 134.993 182.023 135.223C184.605 135.42 186.302 137.264 186.337 140.011L183.265 140.144C183.191 138.865 182.639 138.075 181.835 138.014C180.787 137.934 180.044 139.005 179.905 140.831C179.766 142.658 180.44 143.775 181.658 143.868C182.693 143.947 183.501 143.151 183.787 141.813L186.827 142.425C186.283 145.225 184.193 146.928 181.441 146.718C178.238 146.474 176.34 144.051 176.606 140.568L176.616 140.593Z",
  fill: "#111927"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M190.416 136.169L194.508 136.481L196.686 147.598L193.373 147.346L193.104 145.414L190.388 145.207L189.793 147.073L186.59 146.829L190.428 136.17L190.416 136.169ZM192.91 143.145L192.283 138.994L192.259 138.992L190.925 142.994L192.922 143.146L192.91 143.145Z",
  fill: "#111927"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M198.587 136.792L203.008 137.129L204.459 144.442L204.496 144.445L207.063 137.438L211.46 137.773L210.63 148.661L207.67 148.435L208.226 141.14L208.202 141.139L205.454 148.266L202.933 148.074L201.333 140.615L201.309 140.613L200.753 147.908L197.794 147.683L198.623 136.795L198.587 136.792Z",
  fill: "#111927"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M170.333 148.443L176.775 148.934L176.562 151.735L173.42 151.496L173.273 153.42L175.502 153.59L175.315 156.038L173.087 155.868L172.803 159.582L169.503 159.331L170.333 148.443Z",
  fill: "#111927"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M178.055 149.032L182.415 149.364C185.167 149.574 186.686 151.025 186.516 153.254C186.424 154.459 185.793 155.354 184.736 155.715C185.536 155.984 185.909 156.564 185.84 157.465L185.605 160.546L182.305 160.294L182.528 157.359C182.571 156.799 182.285 156.373 181.81 156.337L180.811 156.261L180.514 160.158L177.214 159.906L178.044 149.019L178.055 149.032ZM181.912 154.201C182.655 154.258 183.167 153.807 183.223 153.064C183.284 152.272 182.845 151.761 182.102 151.704L181.176 151.634L180.986 154.13L181.912 154.201Z",
  fill: "#111927"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M188.103 149.798L194.558 150.29L194.362 152.859L191.074 152.609L190.947 154.265L193.627 154.469L193.458 156.686L190.778 156.482L190.637 158.333L194.072 158.594L193.875 161.176L187.262 160.672L188.092 149.785L188.103 149.798Z",
  fill: "#111927"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M196.019 150.401L202.474 150.893L202.278 153.463L198.99 153.212L198.863 154.868L201.543 155.073L201.374 157.289L198.694 157.085L198.553 158.936L201.988 159.198L201.791 161.78L195.178 161.276L196.008 150.388L196.019 150.401Z",
  fill: "#111927"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M203.068 160.444C203.138 159.518 203.871 158.9 204.833 158.974C205.796 159.047 206.439 159.77 206.368 160.695C206.298 161.621 205.565 162.239 204.59 162.164C203.616 162.09 202.997 161.369 203.068 160.444ZM203.732 153.978L203.96 150.994L206.919 151.22L206.692 154.203L205.612 158.408L204.162 158.298L203.732 153.978Z",
  fill: "#111927"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M229.146 87.8093C230.684 67.6294 215.574 50.0391 195.407 48.5018C175.239 46.9645 157.624 62.0727 156.087 82.2403",
  stroke: "#111927",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M32.851 166.254C18.807 156.147 10.3383 150.047 8.64527 139.634C6.95382 129.23 13.0522 120.752 23.1709 106.716C33.2797 92.6817 39.3797 84.213 49.7831 82.5215C60.1865 80.8301 68.6651 86.9285 82.7009 97.0472C96.735 107.156 105.215 113.264 106.907 123.668C108.598 134.071 102.5 142.55 92.381 156.585C82.2722 170.62 76.1639 179.1 65.7605 180.791C55.3571 182.483 46.8785 176.384 32.8428 166.266L32.851 166.254Z",
  fill: "#7A5AF8"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M35.7689 162.203C49.1604 171.849 56.5963 177.205 64.9565 175.846C73.3168 174.487 78.6811 167.039 88.3188 153.659C97.9648 140.268 103.321 132.832 101.962 124.471C100.602 116.111 93.155 110.747 79.7749 101.109C66.3833 91.4632 58.9474 86.1071 50.5872 87.4664C42.227 88.8256 36.8626 96.273 27.2249 109.653C17.5872 123.033 12.2213 130.471 13.5805 138.831C14.9398 147.191 22.3872 152.555 35.7673 162.193L35.7689 162.203Z",
  stroke: "#111927",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M29.2373 127.704L33.2151 127.057L36.1514 135.708L36.1909 135.702L36.492 126.525L41.1015 125.775L44.3044 134.383L44.3439 134.376L44.3686 125.244L48.3464 124.597L47.4478 138.076L42.6607 138.854L39.5051 130.351L39.4656 130.357L39.1666 139.423L34.3794 140.201L29.257 127.701L29.2373 127.704Z",
  fill: "#111927"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M49.5627 131.076C48.8775 126.862 50.8064 123.833 54.5966 123.217C55.9193 123.001 57.1465 123.197 58.2275 123.801C59.3085 124.406 60.1186 125.338 60.6396 126.611L57.0967 127.876C56.6583 126.924 55.8892 126.431 55.0798 126.562C53.7572 126.777 53.1268 128.197 53.4703 130.309C53.8137 132.421 55.0678 133.717 56.6668 133.457C57.9697 133.245 58.7217 132.262 58.6053 130.923L55.3777 131.448L55.0054 129.158L61.9542 128.028L63.1722 135.52L60.3789 135.974L59.8509 133.973L59.8311 133.976C59.2446 135.54 57.869 136.676 56.2108 136.945C52.8351 137.494 50.2252 135.214 49.5496 131.058L49.5627 131.076Z",
  fill: "#111927"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M62.2843 122.331L67.5649 121.473L71.3335 129.634L71.3729 129.627L72.4014 120.686L77.6426 119.834L79.7545 132.824L76.2111 133.4L74.794 124.684L74.7545 124.691L73.5559 133.831L70.5455 134.321L66.5522 126.024L66.5128 126.031L67.9298 134.746L64.3863 135.322L62.2744 122.333L62.2843 122.331Z",
  fill: "#111927"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M79.0244 119.609L82.9627 118.969L85.0746 131.959L81.1363 132.599L79.0244 119.609Z",
  fill: "#111927"
});

function SvgWgmiLockScamfree(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 252,
    height: 189,
    viewBox: "0 0 252 189",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWgmiLockScamfree);
export default __webpack_public_path__ + "static/media/wgmi-lock-scamfree.78a06519.svg";
export { ForwardRef as ReactComponent };